import * as d3 from 'd3'
export default {

  methods: {
    
   call_Pie_Over(data) {
      d3.select(`#CENTER_TITLE`).transition().duration(20).attr('opacity', 0)
      d3.select(`#DETAIL`).transition().duration(20).attr('opacity', 1)
      d3.select(`#HANDOVER_${data.SYS_CODE}`).transition().duration(20).attr('opacity', .6)

      d3.select(`#VAL_SYS`).text(data.SYS_TOT.toLocaleString('ko-KR'))
      d3.select(`#VAL_SUBSYS`).text(data.SUBSYS_TOT.toLocaleString('ko-KR'))

      this.detail.cols.forEach(col=> {
        d3.select(`#VAL_B_${col.code}`).text(data[`B_${col.code}`].toLocaleString('ko-KR'))
        d3.select(`#VAL_PB_${col.code}`).text(data[`PB_${col.code}`].toLocaleString('ko-KR'))
      })

      this.rawData.forEach(d => {
        if(data.SYS_CODE == d.SYS_CODE) {
          d3.select(`#TOTAL_${d.SYS_CODE}`).transition().duration(20).attr('opacity', 1)
          d3.select(`#ACTUAL_${d.SYS_CODE}`).transition().duration(20).attr('opacity', 1)
        } else {
          d3.select(`#TOTAL_${d.SYS_CODE}`).transition().duration(20).attr('opacity', .3)
          d3.select(`#ACTUAL_${d.SYS_CODE}`).transition().duration(20).attr('opacity', .3)
        }
      })
    },


    call_Pie_Out(data) {
      d3.select(`#DETAIL`).transition().duration(200).attr('opacity', 0)
      d3.select(`#CENTER_TITLE`).transition().duration(200).attr('opacity', 1)
      if(this.current.group != data.SYS_CODE)
      d3.select(`#HANDOVER_${data.SYS_CODE}`).transition().duration(200).attr('opacity', 0)

      this.rawData.forEach(d => {
        d3.select(`#TOTAL_${d.SYS_CODE}`).transition().duration(200).attr('opacity', 1)
        d3.select(`#ACTUAL_${d.SYS_CODE}`).transition().duration(200).attr('opacity', 1)
      })
    },


    call_Handover(selection, group_) {
      selection
      .on('mouseover', ()=> {
        d3.select(`#HANDOVER_${group_}`).transition().duration(20).attr('opacity', .6)
      })
      .on('mouseout', ()=> {
        if(this.current.group == group_) return
        d3.select(`#HANDOVER_${group_}`).transition().duration(250).attr('opacity', 0)
      })
      .on('click', ()=> {
        if(this.current.group == group_) return
        
        this.exec_Handover(group_)
      })
    },

    exec_Handover(group_) {
      d3.select(`#HANDOVER_${this.current.group}`).attr('opacity', 0)
      this.current.group = group_
      d3.select(`#HANDOVER_${group_}`).attr('opacity', .6)

      if(this.systemCanvas) this.systemCanvas.remove()
      if(this.subSysCanvas) this.subSysCanvas.remove()
      if(this.canvasContents) this.canvasContents.remove()

      this.tbl_System(group_)
    },
    
    call_System(selection, d) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', ()=> {

          d3.select(`#SYS_${d.SYS}`).transition().duration(20).attr('opacity', .3)
        })
        .on('mouseout', ()=> {
          if(this.current.sys == d.SYS) return
          d3.select(`#SYS_${d.SYS}`).transition().duration(200).attr('opacity', 0)
        })
      .on('click', ()=> {
        if(this.current.sys == d.SYS) return
        d3.select(`#SYS_${this.current.sys}`).attr('opacity', 0)
        this.current.sys = d.SYS
        d3.select(`#SYS_${d.SYS}`).attr('opacity', .3)

        if(this.subSysCanvas) this.subSysCanvas.remove()
        this.tbl_SubSystem(d.SYS, d.SYS_DESC)
      })
    },

  } 
}